import { render } from "./buildSetting.vue?vue&type=template&id=87dbbfbe&scoped=true"
import script from "./buildSetting.vue?vue&type=script&lang=js"
export * from "./buildSetting.vue?vue&type=script&lang=js"

import "./buildSetting.vue?vue&type=style&index=0&id=87dbbfbe&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87dbbfbe"]])

export default __exports__